module.exports = __webpack_public_path__ + "static/media/fold-selection-tool.cd24d620.png";